import { chakra, useBreakpointValue } from "@smile2impress/components";
import React, { FC } from "react";

import { VideoProps } from "./Video.types";

export const Video: FC<VideoProps> = ({
    className,
    controls = false,
    poster = "",
    src,
    srcMobile,
    ...restProps
}) => {
    const isMobile = useBreakpointValue(
        {
            base: true,
            desktop: false,
        },
        "base"
    );

    return (
        <chakra.video
            className={className}
            controls={controls}
            poster={poster}
            src={isMobile && srcMobile ? srcMobile : src}
            {...restProps}
        >
            <a href={src}>Download video</a>
        </chakra.video>
    );
};
